import { ITermoNotificacao } from "@/interfaces/ITermoNotificacao";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface TermoNotificacaoState {
  items: ITermoNotificacao[];
}

const initialState: TermoNotificacaoState = {
  items: [],
};

const termoNotificacaoSlice = createSlice({
  name: "TERMO_NOTIFICACAO",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<{ item: ITermoNotificacao }>) => {
      const { item } = action.payload;
      state.items.push({ ...item, offlineId: Date.now() });
    },
    remove: (state, action: PayloadAction<{ offlineId: number }>) => {
      state.items = state.items.filter(
        (item) => item.offlineId !== action.payload.offlineId
      );
    },
    update: (state, action: PayloadAction<{ item: ITermoNotificacao }>) => {
      const index = state.items.findIndex(
        (item) => item.offlineId === action.payload.item.offlineId
      );
      state.items[index] = action.payload.item;
    },
  },
});

export default termoNotificacaoSlice.reducer;

export const getTermosNotificacao = (state: RootState) => {
  const listaInvertida = state.termoNotificacao.items.map((_, ind, lista) => {
    return lista[lista.length - ind - 1];
  });

  return listaInvertida;
};
